export default __webpack_public_path__ + "static/media/ico_13.3f9e9fca.png";